const WORDS = ["Cold pressed", "Self-feeding", "Whole fruit chute", "BPA-free", "Quiet & slow", "Recipe Almanac included", "Recipes by Juice Alchemist Kathryn"];

const Sun = () => (
  <svg width="28" height="28" viewBox="0 0 64 64" className="mx-8 shrink-0" aria-hidden="true">
    <path d="M10 40a22 22 0 0 1 44 0z" fill="#C85A32" />
    <path d="M10 32h44M13 25h38" stroke="#181615" strokeWidth="3" />
  </svg>
);

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-[#181615]/10 bg-[#FDFBF7] py-7">
      <div className="marquee-track flex w-max items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display whitespace-nowrap text-4xl font-light italic tracking-tight text-[#181615] sm:text-5xl">{w}</span>
            <Sun />
          </span>
        ))}
      </div>
    </section>
  );
};
